import React from 'react';
import PropTypes from 'prop-types';

// components
import ComponentLoader from '../../../global/ComponentLoader/ComponentLoader';

function importFunc() {
    return import(/* webpackChunkName: "PdpRespNotificationSaveToFolderCallout" */
    './PdpRespNotificationSaveToFolderCallout').then(moduleExport => moduleExport.default);
}

const PdpRespNotificationSaveToFolderCalloutLoader = props => {
    return (
        <ComponentLoader
            {...props}
            useLoadingComponent={false}
            importFunc={importFunc}
            load={props.isEnabled}
        />
    );
};

PdpRespNotificationSaveToFolderCalloutLoader.propTypes = {
    isEnabled: PropTypes.bool.isRequired,
};

export default PdpRespNotificationSaveToFolderCalloutLoader;
